<template>
    <div
        class="HrLine container"
    >
        <hr
            :class="{'is-blue' : blue === true}"
        />
    </div>
</template>
<script>
export default {
    name: 'HrLine',
    props: {
        blue: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
    hr {
        border-top: 1px solid getColour('grey', 'medium');
        border-bottom: 0;

        &.is-blue {
            border-top: 2px solid $action-color;
        }
    }

    .HrLine--thick {
        hr {
            border-top-width: 2px;
        }
    }
</style>
